var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSavedJobs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.758 12.805l-1.914-2.393a1.1 1.1 0 0 0-.858-.412H4.1A1.1 1.1 0 0 0 3 11.1v8.8A1.1 1.1 0 0 0 4.1 21h8.8a1.1 1.1 0 0 0 1.1-1.1v-6.407a1.1 1.1 0 0 0-.242-.688zM6.85 11.1h3.3v1.65h-3.3V11.1zm3.3 8.8h-3.3v-3.3h3.3v3.3zm1.1 0v-3.3a1.1 1.1 0 0 0-1.1-1.1h-3.3a1.1 1.1 0 0 0-1.1 1.1v3.3H4.1v-8.8h1.65v1.65a1.1 1.1 0 0 0 1.1 1.1h3.3a1.1 1.1 0 0 0 1.1-1.1v-1.32l1.65 2.063V19.9h-1.65z",
    fill: "#696871"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 16h-1.125V8.125H8V7h7.875A1.125 1.125 0 0 1 17 8.125V16z",
    fill: "#696871"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 12h-1.143V5.143H12V4h6.857A1.143 1.143 0 0 1 20 5.143V12z",
    fill: "#696871"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSavedJobs);
export default __webpack_public_path__ + "static/media/Saved-Jobs.b0f8e203e59d99bb78f3d374ab488918.svg";
export { ForwardRef as ReactComponent };